import { Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './showToast.scss';
import { Right, Wrong } from '@assets/images/icons';
export type showToastType = {
    type: 'success' | 'error';
    message: string;
};

export const showToast = ({ type, message }: showToastType) => {
    toast(
        <div id="toast" style={{ display: 'flex', alignItems: 'center' }}>
            {type === 'success' ? <Right /> : <Wrong />}
            {message}
        </div>,
        {
            position: 'bottom-right',
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            theme: 'colored',
            transition: Slide,
            draggableDirection: 'x',
            draggablePercent: 100
        }
    );
};
